import '~/js/modules/common'
import Dropdown from '~/js/modules/dropdown'
import '~/pug/blocks/telephone/telephone'
import '~/pug/blocks/products-list/products-list'
